module.exports = __webpack_public_path__ + "public/SiteImages/appStore.png?78096b28";